/* Montirex wireframe — light interactivity for the skeleton */
(function () {
  'use strict';

  /* ---- mobile nav toggle (shows the nav as a simple stacked list) ---- */
  var burger = document.querySelector('.header__burger');
  var nav = document.querySelector('.nav');
  if (burger && nav) {
    burger.addEventListener('click', function () {
      var open = nav.classList.toggle('nav--open');
      nav.style.display = open ? 'flex' : '';
      nav.style.flexDirection = 'column';
      nav.style.position = 'absolute';
      nav.style.top = '100%';
      nav.style.left = '0';
      nav.style.right = '0';
      nav.style.background = '#fff';
      nav.style.padding = open ? '12px 20px' : '';
      nav.style.borderBottom = open ? '1px solid #e6e6e6' : '';
      if (!open) { nav.removeAttribute('style'); }
    });
  }

  /* ---- hero slider (dots) ---- */
  document.querySelectorAll('[data-hero]').forEach(function (hero) {
    var slides = hero.querySelectorAll('.hero__slide');
    var dots = hero.parentElement.querySelectorAll('.hero__dot');
    if (slides.length < 2) return;
    var i = 0, timer;

    function go(n) {
      slides[i].classList.remove('is-active');
      if (dots[i]) dots[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      if (dots[i]) dots[i].classList.add('is-active');
    }
    function auto() { timer = setInterval(function () { go(i + 1); }, 5000); }

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        clearInterval(timer);
        go(parseInt(d.getAttribute('data-goto'), 10));
        auto();
      });
    });
    auto();
  });

  /* ---- product tabs (visual active state only) ---- */
  document.querySelectorAll('.tabs').forEach(function (group) {
    group.querySelectorAll('.tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        group.querySelectorAll('.tab').forEach(function (t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');
      });
    });
  });

  /* ---- carousel arrows (scroll the product row) ---- */
  document.querySelectorAll('.carousel').forEach(function (car) {
    var row = car.querySelector('[data-row]');
    var prev = car.querySelector('.carousel__arrow--prev');
    var next = car.querySelector('.carousel__arrow--next');
    if (!row) return;
    var step = function () { return Math.max(row.clientWidth * 0.8, 240); };
    if (prev) prev.addEventListener('click', function () { row.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { row.scrollBy({ left: step(), behavior: 'smooth' }); });
  });
})();
